export default {
  donation_amt: 'number',
  donation_id: 'number',
  donation_paid: 'boolean',
  anon: 'number',
  test: 'boolean'
}



// WEBPACK FOOTER //
// ./src/store/models/donation.js